/*
    formData should be like the following example:
    let formData = {
        'items': [{
        'id': 36110175633573,
        'quantity': 2
        }]
    };
*/
const sendProductToCart = async(formData) => {
    try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        return response;
    } catch (error){
        console.error('Error:', error);
    }
}
